import React, { useState } from "react";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Binding from "../../../binding";
import { Link } from "react-router-dom";
import config from "./config";

export default function TaskListItem(props) {
  let data = props || {};
  let binding = new Binding({
    id: data.object,
    entitycode: data.entitycode,
    classcode: data.classcode,
    typecode: data.typecode,
    label: data.label,
  });
  let created = data.created ? new Date(data.created) : {};
  let updated = data.updated ? new Date(data.updated) : {};

  const categoryIcons = {
    notice: (
      <i
        title="Требуется действие"
        className="fa fa-info-circle fa-2x text-dark-25 mr-3"
      ></i>
    ),
    interfere: (
      <i
        title="Обычное уведомление"
        className="fa fa-exclamation-circle fa-2x text-warning  mr-3"
      ></i>
    ),
  };

  let rowContent = null;
  if (binding.url) {
    rowContent = (
      <div>
        <Link
          className="text-dark  text-hover-muted"
          title={`Открыть ${binding.label}`}
          to={binding.url}
        >
          {data.text}:
          <div className="mt-1">
            <span className={`mr-2 ${binding.iconClass}`}></span>
            {binding.label || "Без названия"}
          </div>
          <div className="text-muted font-italic">{data.description}</div>
        </Link>
      </div>
    );
  } else {
    rowContent = (
      <div>
        {data.text}
        <div className="text-muted font-italic">{data.description}</div>
      </div>
    );
  }

  const RowButtons = () => {
    return (
      <>
        {data.status === config.STATUS_NEW ||
        data.status === config.STATUS_DELIVERED ? (
          <>
            {data.category === "interfere" ? (
              <>
                <button
                  className="btn btn-light text-hover-success mr-2"
                  title="Принять"
                  onClick={() =>
                    props.onNoticeAction({
                      ...data,
                      status: config.STATUS_APPROVED,
                    })
                  }
                >
                  Принять
                </button>
                <button
                  className="btn   btn-light text-hover-danger"
                  title="Отказать"
                  onClick={() =>
                    props.onNoticeAction({
                      ...data,
                      status: config.STATUS_DECLINED,
                    })
                  }
                >
                  Отказаться
                </button>
              </>
            ) : (
              <>
                <button
                  className="btn   btn-light text-hover-primary "
                  title="Прочитано"
                  onClick={() =>
                    props.onNoticeAction({
                      ...data,
                      status: config.STATUS_VIEWED,
                    })
                  }
                >
                  Прочитано
                </button>
              </>
            )}
          </>
        ) : (
          <>
            <div className="d-flex align-items-center">
              <div>
                <span className="label label-inline">
                  {config.statusLabels[data.status]}
                </span>
              </div>
              <div className="text-dark-50 font-italic ml-4">
                {updated.toLocaleDateString()}
                <br />
                {updated.toLocaleTimeString()}
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <div>
        <div className={`row p-5 border-top  `}>
          <div className="col-lg-2 d-flex align-items-center">
            {categoryIcons[data.category]}
            {created.toLocaleDateString()}
            <br />
            {created.toLocaleTimeString()}
          </div>
          <div className="col-lg-10 d-flex align-items-center justify-content-between">
            <div>{rowContent}</div>
            <div>
              <RowButtons />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
